import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
/**
 * Immutable data rename by specified fields.
 */
export var Rename = function Rename(options) {
  return function (data) {
    if (!options || isEmpty(options)) return data;
    var rename = function rename(v) {
      return Object.entries(v).reduce(function (datum, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return datum[options[key] || key] = value, datum;
      }, {});
    };
    return data.map(rename);
  };
};
Rename.props = {};